import React from 'react';
import {
  Center,
  ConditioningIcon,
  CourageousIcon,
  CuriousIcon,
  DiscerningIcon,
  NourishingIcon,
  ResultsIcon,
  Stack,
  Text,
} from '../../components';

export const coreValuesData = [
  {
    icon: <NourishingIcon />,
    title: 'Devoted to the Customer',
    description:
      'We work to create magical experiences for our customers. We strive to earn our community’s trust, and to bring them joy, with each decision we make.',
  },
  {
    icon: <CourageousIcon />,
    title: 'Courageous',
    description:
      'We think big, take risks, and know that courage fuels innovation. We speak up to share ideas and solve challenges, and we encourage each other to do the same.',
  },
  {
    icon: <DiscerningIcon />,
    title: 'Discerning',
    description:
      'We apply rigorous thinking and integrity in the pursuit of excellence. We understand the “why”, nurture healthy debate, and see around corners to make decisions that yield the best outcomes.',
  },
  {
    icon: <ConditioningIcon />,
    title: 'Inclusive',
    description:
      'We practice inclusion by building and developing diverse teams. We seek out different perspectives, listen intently, and collaborate with empathy.',
  },
  {
    icon: <CuriousIcon />,
    title: 'Curious',
    description:
      'We challenge our assumptions, ask questions, and grow from our mistakes. We eagerly learn in order to broaden our knowledge and better understand the world around us.',
  },
  {
    icon: <ResultsIcon />,
    title: 'Results-Driven',
    description:
      'We are individually and collectively responsible for Glossier’s success. We set meaningful goals, regularly measure progress and consistently achieve strong results.',
  },
];

export const CoreValuesComponent = (props) => {
  let { coreValue, align } = props;
  let { icon, title, description } = coreValue || {
    icon: '',
    title: '',
    description: '',
  };
  return (
    <Stack size={4}>
      {align === 'left' ? icon : <Center>{icon}</Center>}
      <Text align={align} textType="primary1">
        {title}
      </Text>
      <Text align={align} textType="primary2">
        {description}
      </Text>
    </Stack>
  );
};
